import React from "react";

export default function Overview({ PropertyObject }) {
  return (
    <>
      <h6 className="title fw-6">Overview</h6>
      <ul className="info-box">
        {
          PropertyObject.PropertyGeneratedId && (
            <li className="item">
              <a href="#" className="box-icon w-52">
                <i className="icon icon-house-line" />
              </a>
              <div className="content">
                <span className="label">ID:</span>
                <span>{PropertyObject.PropertyGeneratedId}</span>
              </div>
            </li>
          )
        }
        {
          PropertyObject.PropertyTitle && (
            <li className="item">
              <a href="#" className="box-icon w-52">
                <i className="icon icon-sliders-horizontal" />
              </a>
              <div className="content">
                <span className="label">Type:</span>
                <span>{PropertyObject.PropertyTypeName}</span>
              </div>
            </li>)

        }
        {
          PropertyObject.Garages && (
            <li className="item">
              <a href="#" className="box-icon w-52">
                <i className="icon icon-garage" />
              </a>
              <div className="content">
                <span className="label">Garages:</span>
                <span>{PropertyObject.Garages}</span>
              </div>
            </li>
          )
        }
        {
          PropertyObject.GaragesSize && (
            <li className="item">
              <a href="#" className="box-icon w-52">
                <i className="icon icon-garage" />
              </a>
              <div className="content">
                <span className="label">Garages Size:</span>
                <span>{PropertyObject.GaragesSize}</span>
              </div>
            </li>
          )
        }
        {
          PropertyObject.NoofRoom && (
            <li className="item">
              <a href="#" className="box-icon w-52">
                <i className="icon icon-bed1" />
              </a>
              <div className="content">
                <span className="label">Bedrooms:</span>
                <span>{PropertyObject.NoofRoom} Rooms</span>
              </div>
            </li>
          )
        }
        {
          PropertyObject.NoofWashroom && (
            <li className="item">
              <a href="#" className="box-icon w-52">
                <i className="icon icon-bathtub" />
              </a>
              <div className="content">
                <span className="label">Bathrooms:</span>
                <span>{PropertyObject.NoofWashroom} Rooms</span>
              </div>
            </li>
          )
        }
        {
          PropertyObject.LandSize && (
            <li className="item">
              <a href="#" className="box-icon w-52">
                <i className="icon icon-crop" />
              </a>
              <div className="content">
                <span className="label">Land Size:</span>
                <span>{PropertyObject.LandSize} {PropertyObject.LandSizeUnit}</span>
              </div>
            </li>
          )
        }

        {
          PropertyObject.BuiltUpArea && (
            <li className="item">
              <a href="#" className="box-icon w-52">
                <i className="icon icon-ruler" />
              </a>
              <div className="content">
                <span className="label">Constructed Size:</span>
                <span>{PropertyObject.BuiltUpArea} {PropertyObject.BuiltUpAreaUnitSize}</span>
              </div>
            </li>
          )
        }
        {
          PropertyObject.CarpetArea && (
            <li className="item">
              <a href="#" className="box-icon w-52">
                <i className="icon icon-ruler" />
              </a>
              <div className="content">
                <span className="label">Carpet Size:</span>
                <span>{PropertyObject.CarpetArea} {PropertyObject.CarpetAreaUnitSize}</span>
              </div>
            </li>
          )
        }
        {
          PropertyObject.SuperArea && (
            <li className="item">
              <a href="#" className="box-icon w-52">
                <i className="icon icon-ruler" />
              </a>
              <div className="content">
                <span className="label">Super Area:</span>
                <span>{PropertyObject.SuperArea} {PropertyObject.SuperAreaUnitSize}</span>
              </div>
            </li>
          )
        }


        {
          PropertyObject.AgeofProperty && (
            <li className="item">
              <a href="#" className="box-icon w-52">
                <i className="icon icon-hammer" />
              </a>
              <div className="content">
                <span className="label">Property Age:</span>
                <span>{PropertyObject.AgeofProperty}</span>
              </div>
            </li>
          )
        }
      </ul>
    </>
  );
}
